module.exports = __webpack_public_path__ + "static/media/backFirebaseReact.ff76de3e.jpg";